<template>
  <v-layout align-center justify-start>
    <v-flex xs9>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-autocomplete
            v-on="on"
            :items="freightClasses"
            :value="value"
            @input="v => $emit('input', v)"
          >
            <template v-slot:item="props">
              <v-list-tile-content>
                <v-tooltip top>
                  <template v-slot:activator="propsActivator">
                    <v-list-tile-title v-on="propsActivator.on" >{{props.item.text}}</v-list-tile-title>
                  </template>
                  {{ props.item.description }}
                </v-tooltip>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </template>
        {{ currentItem.description || $t('noDataAvailable') }}
      </v-tooltip>
    </v-flex>
    <v-flex>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn ma-0 v-on="on" small icon @click="calFreightClass"><v-icon>calculate</v-icon></v-btn>
        </template>
        {{ $t('calculateFreightClass') }}
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import { measurementTools, toMoney } from '@/utils/tools'

const freightClassMap = {
  CLASS_050: {
    text: '50',
    value: 'CLASS_050',
    description: `Durable freight that fits on a standard 4' × 4' pallet`,
    range: { max: Infinity, min: 50 }
  },
  CLASS_055: {
    text: '55',
    value: 'CLASS_055',
    description: `Bricks, cement, hardwood flooring, construction materials`,
    range: { max: 50, min: 35 }
  },
  CLASS_060: {
    text: '60',
    value: 'CLASS_060',
    description: `Car accessories, car parts`,
    range: { max: 35, min: 30 }
  },
  CLASS_065: {
    text: '65',
    value: 'CLASS_065',
    description: `Car accessories and parts, boxed books, bottled drinks`,
    range: { max: 30, min: 22.5 }
  },
  CLASS_070: {
    text: '70',
    value: 'CLASS_070',
    description: `Car accessories and parts, auto engines, food items`,
    range: { max: 22.5, min: 15 }
  },
  CLASS_077_5: {
    text: '77.5',
    value: 'CLASS_077_5',
    description: `Tires, bathroom fixtures 13.5–15 lbs.`,
    range: { max: 15, min: 13.5 }
  },
  CLASS_085: {
    text: '85',
    value: 'CLASS_085',
    description: `Crated machinery, cast iron stoves`,
    range: { max: 13.5, min: 12 }
  },
  CLASS_092_5: {
    text: '92.5',
    value: 'CLASS_092_5',
    description: `Computers, monitors, refrigerators`,
    range: { max: 12, min: 10.5 }
  },
  CLASS_100: {
    text: '100',
    value: 'CLASS_100',
    description: `Car covers, canvas, boat covers, wine cases, caskets`,
    range: { max: 10.5, min: 9 }
  },
  CLASS_110: {
    text: '110',
    value: 'CLASS_110',
    description: `Cabinets, framed art, table saws`,
    range: { max: 9, min: 8 }
  },
  CLASS_125: {
    text: '125',
    value: 'CLASS_125',
    description: `Small home appliances`,
    range: { max: 8, min: 7 }
  },
  CLASS_150: {
    text: '150',
    value: 'CLASS_150',
    description: `Auto sheet metal, bookcases`,
    range: { max: 7, min: 6 }
  },
  CLASS_175: {
    text: '175',
    value: 'CLASS_175',
    description: `Clothing, couches, stuffed furniture`,
    range: { max: 6, min: 5 }
  },
  CLASS_200: {
    text: '200',
    value: 'CLASS_200',
    description: `Sheet metal parts, aluminum tables, packaged mattresses, aircraft parts`,
    range: { max: 5, min: 4 }
  },
  CLASS_250: {
    text: '250',
    value: 'CLASS_250',
    description: `Mattresses and box springs, plasma TVs, bamboo furniture`,
    range: { max: 4, min: 3 }
  },
  CLASS_300: {
    text: '300',
    value: 'CLASS_300',
    description: `Model boats, assembled chairs, tables, wood cabinets`,
    range: { max: 3, min: 2 }
  },
  CLASS_400: {
    text: '400',
    value: 'CLASS_400',
    description: `Deer antlers 1–2 lbs.`,
    range: { max: 2, min: 1 }
  },
  CLASS_500: {
    text: '500',
    value: 'CLASS_500',
    description: `Gold dust, ping pong balls`,
    range: { max: 1, min: 0 }
  }
}

export default {
  name: 'LabelFreightClassSelector',
  mixins: {
    measurementTools
  },
  data () {
    return {}
  },
  computed: {
     
    freightClasses () {
      return Object.values(freightClassMap)
    },
    currentItem () {
      return freightClassMap[this.value] || {}
    }
  },
  methods: {
    calFreightClass () {
      const volume = toMoney(
        (this.isMeasurementMetric 

          ? this.cm_inch(this.length) * 
            this.cm_inch(this.width) * 
            this.cm_inch(this.height)

          : this.length * this.width * this.height
        ) / 1728
      )
      
      const lbsPerFeet3 = toMoney((this.isMeasurementMetric ? this.kg_lbs(this.weight) : this.weight) / volume)

      const freightClass = this.freightClasses.find(({range = {}}) => {
        const {min = Infinity, max = 0} = range
        return lbsPerFeet3 >= min && lbsPerFeet3 < max
      })
      if (freightClass) {
        this.$emit('input', freightClass.value)
      } else {
        this.$store.dispatch('showToast', {info: this.$t('cannotCalFreightClass'), level: 'error'})
      }
    }
  },
  props: {
    value: String,
    isMeasurementMetric: Boolean,
    length: Number,
    width: Number,
    height: Number,
    weight: Number
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/LabelFreightClassSelector.vue